
import { useSelector } from "react-redux";
import { Box, Checkbox, Grid, Typography } from "@mui/material";
import { separadorMillares, usePrecioCarritoXRole } from "../../../hooks";
import { useGlobalValueStore } from "../../../stores";
import { roleCompra } from "../../../data";
import { useTheme } from "@emotion/react";




export const PagoOrdenOp = ({ data=[] }) => {


    const theme = useTheme();
    const primary = theme.palette.primary.main;
    const { iva, cambiarIva } = useGlobalValueStore();
    const { view } = useSelector( state => state.iva );
    const { obtenerPreciosCarritoIva } = usePrecioCarritoXRole();
    const { valorIVA, totalView } = obtenerPreciosCarritoIva(data);


    return (

        <Grid container sx={{ display:'flex', flexDirection:'column' }}>
            <Box sx={{width:'100%', textAlign:'center'}}>
                <Typography variant="h4" sx={{fontSize:'25px'}}>Total de la Orden</Typography>
            </Box>

            <Box sx={{width:'100%', textAlign:'center'}}>
                <Typography variant="span" sx={{letterSpacing:'-0.3px'}}>Todos Los valores en esta orden de pedido son antes de IVA.</Typography>
            </Box>

            <Box sx={{mt:3, width:'100%', textAlign:'left'}}>
                <Checkbox sx={{p:0, mr:1}} checked={iva} onChange={() => cambiarIva(!iva)} />
                <Typography variant="body" color={(iva) ? 'primary' : ''} >
                    Seleccione si desea Facturacion Electronica.
                </Typography>
            </Box>

            {(iva) 
            ?   <>
                    <Grid container sx={{ display:'flex', justifyContent:'space-between', mt:2 }}>
                        <Typography variant="h3">Subtotal {roleCompra[view]}:</Typography>
                        <Typography variant="h3">{`$${separadorMillares(totalView)}`}</Typography>
                    </Grid>

                    <Grid container sx={{ display:'flex', justifyContent:'space-between' }}>
                        <Typography variant="h3" sx={{ color: primary }}>IVA (19%)</Typography>
                        <Typography variant="h3" sx={{ color: primary }}>{`$${separadorMillares(valorIVA)}`}</Typography>
                    </Grid>

                    <Grid container sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                        <Typography variant="h3">Total {roleCompra[view]}: </Typography>
                        <Typography variant="h3">{`$${separadorMillares(totalView + valorIVA)}`}</Typography>
                    </Grid>
                </>
            :    <Grid container sx={{ display: 'flex', justifyContent: 'space-between', mt:3 }}>
                    <Typography variant="h3">Total {roleCompra[view]}:</Typography>
                    <Typography variant="h3">{`$${separadorMillares(totalView)}`}</Typography>
                </Grid>
            }
        </Grid>
    )
}
